import { render, staticRenderFns } from "./Documentacion.vue?vue&type=template&id=87b0d808&scoped=true&"
import script from "./Documentacion.vue?vue&type=script&lang=js&"
export * from "./Documentacion.vue?vue&type=script&lang=js&"
import style0 from "./Documentacion.vue?vue&type=style&index=0&id=87b0d808&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b0d808",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFileInput } from 'vuetify/lib/components/VFileInput';
installComponents(component, {VFileInput})
